import BaseModelInvestment from "@/models/BaseModelInvestment.js";

export const ProgramInfoTemplate = {
	parent: {
		Id: "",
		ProgramID: "",
		Title: "",
		Alias: "",
		EIN: "",
		FormationDate: "",
		InitialAwardDate: "",
		IncomeSource: "",
		FinalCloseDate: "",
		MultiClass: "",
		StateSource: "",
		Note: "",
		InvestmentId: "",
		InvestmentTitle: ""
	},
	children: {
		UnitClass: [],
		VestingSchedule: []
	}
}

export const PartnerGridConfig = {
	list: 'Issuance',
	grid: {
		gridId: 'InitialIssuanceGrid',
		height: 500,
		checkbox: false,
		edit: false,
		delete: true,

		pageSize: 10,
		groupable: false
	},
	columns: {
		PartnerKey: {
			dataName: 'PartnerKey',
			type: 'string',
			title: 'PartnerKey',
			width: 100,
			hidden: true
		},
		PartnerId: {
			dataName: 'PartnerId',
			type: 'string',
			title: 'Partner Id',
			width: 100,
			hidden: false
		},
		PartnerName: {
			dataName: 'PartnerName',
			type: 'string',
			title: 'Partner Name',
			width: 100,
			hidden: false
		},
		TSDocumentID: {
			dataName: 'TSDocumentID',
			type: 'string',
			title: 'T S DocumentID',
			width: 100,
			hidden: false
		},
		UnitClass: {
			dataName: 'UnitClass',
			type: 'string',
			title: 'Unit Class',
			width: 150,
			hidden: false
		},
		Units: {
			dataName: 'Units',
			type: 'string',
			title: 'Units',
			width: 100,
			hidden: false
		},
		UnitType: {
			dataName: 'UnitType',
			type: 'string',
			title: 'Unit Type',
			width: 100,
			hidden: false
		},
		VestingType: {
			dataName: 'VestingType',
			type: 'string',
			title: 'Vesting Type',
			width: 120,
			hidden: false
		},
		DateIssued: {
			dataName: 'DateIssued',
			type: 'string',
			title: 'Date Issued',
			width: 100,
			hidden: false
		},
		Notes: {
			dataName: 'Notes',
			type: 'string',
			title: 'Notes',
			width: 100,
			hidden: false
		},
		IsNewPartner: {
			dataName: 'IsNewPartner',
			type: 'string',
			title: 'Validation',
			width: 100,
			hidden: false
		},

	}
}

export const InvestmentConfig = {
	list: BaseModelInvestment.list,
	columns: BaseModelInvestment.columns
}

export const IssuanceBatchIdUpdateConfig = {
	list: "Issuance",
	columns: {
		Id: {
			dataName: "Id",
			type: "number"
		},
		BatchGUID: {
			dataName: "BatchGUID",
			type: "string"
		}
	}
};